import { useState } from "react";
import type { CashDrawerTransactionType } from "../types";

interface CashDrawerActionModalProps {
  title: string;
  type: CashDrawerTransactionType;
  onConfirm: (amountCents: number, note: string) => void;
  onCancel: () => void;
}

/** Modal for Cash Drop, Cash Refill, or Opening Float. */
export function CashDrawerActionModal({
  title,
  type,
  onConfirm,
  onCancel,
}: CashDrawerActionModalProps) {
  const [amountDollars, setAmountDollars] = useState("");
  const [note, setNote] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = parseFloat(amountDollars);
    if (Number.isNaN(parsed) || parsed <= 0) return;
    const amountCents = Math.round(parsed * 100);
    if (type === "CASH_DROP") {
      onConfirm(-amountCents, note.trim());
    } else {
      onConfirm(amountCents, note.trim());
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cash-drawer-modal-title"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h2 id="cash-drawer-modal-title" className="text-lg font-semibold text-gray-900 mb-2">
          {title}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Amount ($)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={amountDollars}
              onChange={(e) => setAmountDollars(e.target.value)}
              placeholder="0.00"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FD7657] focus:border-[#FD7657]"
              required
              autoFocus
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Note (optional)
            </label>
            <input
              type="text"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="e.g. End of day drop"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FD7657] focus:border-[#FD7657]"
            />
          </div>
          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!amountDollars || parseFloat(amountDollars) <= 0}
              className="px-4 py-2 rounded-lg text-sm font-semibold text-white bg-[#FD7657] hover:bg-[#e66a4a] disabled:opacity-50 transition-colors"
            >
              Confirm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
